(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  function initV2Headers(root) {
    root.querySelectorAll('.v2-header').forEach(function (header) {
      if (header.dataset.initialized === 'true') return;
      header.dataset.initialized = 'true';

      function setHeaderHeight() {
        document.documentElement.style.setProperty('--header-height', header.offsetHeight + 'px');
      }
      setHeaderHeight();
      window.addEventListener('resize', setHeaderHeight);

      var burger = header.querySelector('[data-burger]');
      var mobileMenu = document.querySelector('[data-mobile-menu]');
      var closeBtn = mobileMenu ? mobileMenu.querySelector('[data-mobile-close]') : null;
      if (!burger || !mobileMenu) return;

      function openMenu() {
        mobileMenu.classList.add('open');
        mobileMenu.setAttribute('aria-hidden', 'false');
        burger.setAttribute('aria-expanded', 'true');
      }
      function closeMenu() {
        mobileMenu.classList.remove('open');
        mobileMenu.setAttribute('aria-hidden', 'true');
        burger.setAttribute('aria-expanded', 'false');
      }
      burger.addEventListener('click', openMenu);
      if (closeBtn) closeBtn.addEventListener('click', closeMenu);
      mobileMenu.querySelectorAll('.v2-mobile-menu__link').forEach(function (link) {
        link.addEventListener('click', closeMenu);
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') closeMenu();
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () { initV2Headers(document); });
  document.addEventListener('shopify:section:load', function (e) { initV2Headers(e.target); });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["v2-merch"] && !Shopify.designMode) return;
  try {
    
  function postCartAdd(url, items) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (res) {
      if (!res.ok) return res.json().then(function (err) { throw err; });
      return res.json();
    });
  }

  function refreshCartBadge() {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
      document.dispatchEvent(new CustomEvent('score:cart:updated', { detail: cart }));
    }).catch(function () {});
  }

  function initV2Merch(root) {
    root.querySelectorAll('.v2-merch').forEach(function (hub) {
      if (hub.dataset.initialized === 'true') return;
      hub.dataset.initialized = 'true';

      var cartAddUrl = hub.dataset.cartAddUrl;
      var dataEl = hub.querySelector('[data-merch-product-data]');
      var products = [];
      if (dataEl) { try { products = JSON.parse(dataEl.textContent); } catch (e) { products = []; } }

      var overlay = hub.querySelector('[data-drawer-overlay]');
      var drawer = hub.querySelector('[data-drawer]');
      var drawerName = hub.querySelector('[data-drawer-name]');
      var sizeRow = hub.querySelector('[data-drawer-sizes]');
      var stockNote = hub.querySelector('[data-drawer-note]');
      var drawerAddBtn = hub.querySelector('[data-drawer-add]');
      var selectedVariantId = null;

      function openDrawer(productId, productName) {
        var product = products.filter(function (p) { return String(p.id) === String(productId); })[0];
        if (!product) return;
        drawerName.textContent = productName;
        sizeRow.innerHTML = '';
        stockNote.textContent = '';
        selectedVariantId = null;

        product.variants.forEach(function (variant) {
          var lowStock = variant.inventory_management === 'shopify' && variant.inventory_quantity > 0 && variant.inventory_quantity <= 5;
          var oos = !variant.available;
          var btn = document.createElement('button');
          btn.className = 'v2-size-pill';
          btn.type = 'button';
          btn.textContent = variant.title === 'Default Title' ? 'Add to Bag' : variant.title;
          if (oos) btn.disabled = true;
          btn.setAttribute('aria-pressed', 'false');
          btn.addEventListener('click', function () {
            sizeRow.querySelectorAll('.v2-size-pill').forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
            btn.setAttribute('aria-pressed', 'true');
            selectedVariantId = variant.id;
            stockNote.textContent = lowStock ? ('Only ' + variant.inventory_quantity + ' left') : '';
          });
          sizeRow.appendChild(btn);
        });

        overlay.classList.add('open'); drawer.classList.add('open'); drawer.setAttribute('aria-hidden', 'false');
      }
      function closeDrawer() {
        overlay.classList.remove('open'); drawer.classList.remove('open'); drawer.setAttribute('aria-hidden', 'true');
      }

      hub.querySelectorAll('[data-quick-add]').forEach(function (btn) {
        btn.addEventListener('click', function () { openDrawer(btn.dataset.productId, btn.dataset.productName); });
      });
      if (overlay) overlay.addEventListener('click', closeDrawer);
      var closeBtn = hub.querySelector('[data-drawer-close]');
      if (closeBtn) closeBtn.addEventListener('click', closeDrawer);

      if (drawerAddBtn) drawerAddBtn.addEventListener('click', function () {
        if (!selectedVariantId) { stockNote.textContent = 'Select an option to continue'; return; }
        drawerAddBtn.disabled = true;
        postCartAdd(cartAddUrl, [{ id: selectedVariantId, quantity: 1 }])
          .then(function () { refreshCartBadge(); closeDrawer(); })
          .catch(function () { stockNote.textContent = 'Could not add to cart — please try again.'; })
          .finally(function () { drawerAddBtn.disabled = false; });
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () { initV2Merch(document); });
  document.addEventListener('shopify:section:load', function (e) { initV2Merch(e.target); });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["v2-music"] && !Shopify.designMode) return;
  try {
    
  function initV2MusicTimelines(root) {
    root.querySelectorAll('.v2-music').forEach(function (section) {
      if (section.dataset.initialized === 'true') return;
      section.dataset.initialized = 'true';

      var viewport = section.querySelector('[data-viewport]');
      var track = section.querySelector('[data-track]');
      if (!viewport || !track) return;

      var slides = section.querySelectorAll('.v2-timeline-slide');
      var tabs = section.querySelectorAll('[data-tab]');
      if (slides.length === 0) return;

      var index = 0;
      function slideWidth() { return slides[0].getBoundingClientRect().width; }
      function goTo(i) {
        index = Math.max(0, Math.min(i, slides.length - 1));
        track.style.transform = 'translateX(-' + (index * slideWidth()) + 'px)';
        tabs.forEach(function (t, ti) { t.setAttribute('aria-selected', ti === index ? 'true' : 'false'); });
      }
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () { goTo(parseInt(tab.dataset.index, 10)); });
      });
      window.addEventListener('resize', function () { goTo(index); });

      var isDown = false, startX = 0, currentTranslate = 0;
      function pointerX(e) { return e.touches ? e.touches[0].clientX : e.clientX; }
      function startDrag(e) { isDown = true; track.classList.add('dragging'); startX = pointerX(e); currentTranslate = -index * slideWidth(); }
      function moveDrag(e) { if (!isDown) return; var dx = pointerX(e) - startX; track.style.transform = 'translateX(' + (currentTranslate + dx) + 'px)'; }
      function endDrag(e) {
        if (!isDown) return; isDown = false; track.classList.remove('dragging');
        var dx = (e.changedTouches ? e.changedTouches[0].clientX : e.clientX) - startX;
        if (dx < -50) goTo(index + 1 >= slides.length ? 0 : index + 1);
        else if (dx > 50) goTo(index - 1 < 0 ? slides.length - 1 : index - 1);
        else goTo(index);
      }
      track.addEventListener('mousedown', startDrag);
      window.addEventListener('mousemove', moveDrag);
      window.addEventListener('mouseup', endDrag);
      track.addEventListener('touchstart', startDrag, { passive: true });
      track.addEventListener('touchmove', moveDrag, { passive: true });
      track.addEventListener('touchend', endDrag);

      viewport.setAttribute('tabindex', '0');
      viewport.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') goTo(index + 1 >= slides.length ? 0 : index + 1);
        if (e.key === 'ArrowLeft') goTo(index - 1 < 0 ? slides.length - 1 : index - 1);
      });
      goTo(0);
    });
  }
  document.addEventListener('DOMContentLoaded', function () { initV2MusicTimelines(document); });
  document.addEventListener('shopify:section:load', function (e) { initV2MusicTimelines(e.target); });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["v2-timeline"] && !Shopify.designMode) return;
  try {
    
  function initV2Timelines(root) {
    root.querySelectorAll('[data-timeline]').forEach(function (section) {
      if (section.dataset.initialized === 'true') return;
      section.dataset.initialized = 'true';

      var sticky = section.querySelector('[data-sticky]');
      var track = section.querySelector('[data-track]');
      var panels = Array.prototype.slice.call(section.querySelectorAll('[data-panel]'));
      var progressFill = section.querySelector('[data-progress-fill]');
      var markers = Array.prototype.slice.call(section.querySelectorAll('[data-marker]'));
      if (!sticky || !track || panels.length === 0) return;

      var isDesktop = window.matchMedia('(min-width: 900px)').matches;
      var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      function setActivePanel(panel) {
        panels.forEach(function (p) {
          if (p === panel) return;
          p.classList.remove('is-active');
          var v = p.querySelector('video');
          if (v) v.pause();
        });
        if (panel && !panel.classList.contains('is-active')) {
          panel.classList.add('is-active');
          var newVideo = panel.querySelector('video');
          if (newVideo) {
            newVideo.muted = true;
            newVideo.play().catch(function () {});
          }
        }
      }

      // ---- Fallback: plain swipeable row, native scroll + snap ----
      if (!isDesktop || reduceMotion) {
        var io = 'IntersectionObserver' in window
          ? new IntersectionObserver(function (entries) {
              entries.forEach(function (entry) {
                if (entry.isIntersecting && entry.intersectionRatio > 0.6) {
                  setActivePanel(entry.target);
                }
              });
            }, { root: track, threshold: [0.6] })
          : null;
        if (io) panels.forEach(function (p) { io.observe(p); });

        markers.forEach(function (marker, i) {
          marker.addEventListener('click', function () {
            var target = panels[i];
            if (target) target.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
          });
        });
        return;
      }

      // ---- Pinned, scroll-driven mode ----
      section.classList.add('v2-timeline--pinned');

      var scrollDistance = 0;
      var pinStartY = 0;
      function measure() {
        scrollDistance = Math.max(track.scrollWidth - window.innerWidth, 0);
        var stickyOffset = sticky.offsetTop; // height of the heading area above the pinned zone
        pinStartY = window.pageYOffset + section.getBoundingClientRect().top + stickyOffset;
        section.style.height = (stickyOffset + scrollDistance + window.innerHeight) + 'px';
      }
      measure();
      window.addEventListener('resize', measure);

      function onScroll() {
        var scrolled = Math.min(Math.max(window.pageYOffset - pinStartY, 0), scrollDistance);
        var progress = scrollDistance > 0 ? scrolled / scrollDistance : 0;

        track.style.transform = 'translateX(-' + (progress * scrollDistance) + 'px)';
        if (progressFill) progressFill.style.width = (progress * 100) + '%';

        if (markers.length > 1) {
          var activeMarkerIndex = Math.round(progress * (markers.length - 1));
          markers.forEach(function (m, i) {
            m.setAttribute('aria-selected', i === activeMarkerIndex ? 'true' : 'false');
          });
        }

        var centerX = window.innerWidth / 2;
        var closest = null, closestDist = Infinity;
        panels.forEach(function (panel) {
          var pRect = panel.getBoundingClientRect();
          var panelCenter = pRect.left + pRect.width / 2;
          var dist = Math.abs(panelCenter - centerX);
          if (dist < closestDist) { closestDist = dist; closest = panel; }
        });
        setActivePanel(closest);
      }
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();

      markers.forEach(function (marker, i) {
        marker.addEventListener('click', function () {
          var target = panels[i];
          if (!target || scrollDistance === 0) return;
          var panelProgress = Math.min(Math.max(target.offsetLeft / scrollDistance, 0), 1);
          var sectionTop = window.pageYOffset + section.getBoundingClientRect().top;
          window.scrollTo({ top: sectionTop + panelProgress * scrollDistance, behavior: 'smooth' });
        });
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () { initV2Timelines(document); });
  document.addEventListener('shopify:section:load', function (e) { initV2Timelines(e.target); });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["v2-tour-posters"] && !Shopify.designMode) return;
  try {
    
  function initV2TourPosters(root) {
    root.querySelectorAll('.v2-tour-posters').forEach(function (section) {
      if (section.dataset.initialized === 'true') return;
      section.dataset.initialized = 'true';

      var viewport = section.querySelector('[data-viewport]');
      var track = section.querySelector('[data-track]');
      if (!viewport || !track) return;

      var slides = section.querySelectorAll('.v2-poster-slide');
      var prevBtn = section.querySelector('[data-prev]');
      var nextBtn = section.querySelector('[data-next]');
      var counterCurrent = section.querySelector('[data-counter-current]');
      var captions = section.querySelectorAll('[data-caption]');
      if (slides.length === 0) return;

      var index = 0;
      var autoplayMs = parseInt(section.dataset.autoplay || '0', 10);
      var autoplayTimer = null;
      var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      function slideWidth() { return slides[0].getBoundingClientRect().width; }
      function goTo(i) {
        index = Math.max(0, Math.min(i, slides.length - 1));
        track.style.transform = 'translateX(-' + (index * slideWidth()) + 'px)';
        if (counterCurrent) counterCurrent.textContent = index + 1;
        captions.forEach(function (c) { c.hidden = parseInt(c.dataset.index, 10) !== index; });
      }

      if (prevBtn) prevBtn.addEventListener('click', function () { goTo(index - 1 < 0 ? slides.length - 1 : index - 1); resetAutoplay(); });
      if (nextBtn) nextBtn.addEventListener('click', function () { goTo(index + 1 >= slides.length ? 0 : index + 1); resetAutoplay(); });
      window.addEventListener('resize', function () { goTo(index); });

      var isDown = false, startX = 0, currentTranslate = 0;
      function pointerX(e) { return e.touches ? e.touches[0].clientX : e.clientX; }
      function startDrag(e) { isDown = true; track.classList.add('dragging'); startX = pointerX(e); currentTranslate = -index * slideWidth(); }
      function moveDrag(e) { if (!isDown) return; var dx = pointerX(e) - startX; track.style.transform = 'translateX(' + (currentTranslate + dx) + 'px)'; }
      function endDrag(e) {
        if (!isDown) return; isDown = false; track.classList.remove('dragging');
        var dx = (e.changedTouches ? e.changedTouches[0].clientX : e.clientX) - startX;
        if (dx < -50) goTo(index + 1 >= slides.length ? 0 : index + 1);
        else if (dx > 50) goTo(index - 1 < 0 ? slides.length - 1 : index - 1);
        else goTo(index);
        resetAutoplay();
      }
      track.addEventListener('mousedown', startDrag);
      window.addEventListener('mousemove', moveDrag);
      window.addEventListener('mouseup', endDrag);
      track.addEventListener('touchstart', startDrag, { passive: true });
      track.addEventListener('touchmove', moveDrag, { passive: true });
      track.addEventListener('touchend', endDrag);

      viewport.setAttribute('tabindex', '0');
      viewport.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { goTo(index + 1 >= slides.length ? 0 : index + 1); resetAutoplay(); }
        if (e.key === 'ArrowLeft') { goTo(index - 1 < 0 ? slides.length - 1 : index - 1); resetAutoplay(); }
      });

      function startAutoplay() {
        if (!autoplayMs || reduceMotion || slides.length < 2) return;
        autoplayTimer = setInterval(function () {
          goTo(index + 1 >= slides.length ? 0 : index + 1);
        }, autoplayMs);
      }
      function resetAutoplay() {
        if (autoplayTimer) clearInterval(autoplayTimer);
        startAutoplay();
      }
      viewport.addEventListener('mouseenter', function () { if (autoplayTimer) clearInterval(autoplayTimer); });
      viewport.addEventListener('mouseleave', resetAutoplay);

      goTo(0);
      startAutoplay();
    });
  }

  document.addEventListener('DOMContentLoaded', function () { initV2TourPosters(document); });
  document.addEventListener('shopify:section:load', function (e) { initV2TourPosters(e.target); });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["v2-tour"] && !Shopify.designMode) return;
  try {
    
  function initV2Tours(root) {
    root.querySelectorAll('.v2-tour').forEach(function (section) {
      if (section.dataset.initialized === 'true') return;
      section.dataset.initialized = 'true';

      var pills = section.querySelectorAll('.v2-filter-pill');
      var cards = section.querySelectorAll('.v2-tour-card');
      var tabs = section.querySelectorAll('.v2-tour-card__tab');

      function applyFilter(region) {
        cards.forEach(function (card) {
          card.hidden = !(region === 'all' || card.dataset.region === region);
        });
      }
      pills.forEach(function (pill) {
        pill.addEventListener('click', function () {
          pills.forEach(function (p) { p.setAttribute('aria-pressed', 'false'); });
          pill.setAttribute('aria-pressed', 'true');
          applyFilter(pill.dataset.regionFilter);
        });
      });

      function closeAll(except) {
        tabs.forEach(function (t) { if (t !== except) t.setAttribute('aria-expanded', 'false'); });
        section.querySelectorAll('.v2-tour-card__panel').forEach(function (p) {
          if (!except || p.id !== except.getAttribute('aria-controls')) p.classList.remove('open');
        });
      }
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var panel = section.querySelector('#' + tab.getAttribute('aria-controls'));
          var isOpen = tab.getAttribute('aria-expanded') === 'true';
          closeAll(null);
          if (!isOpen && panel) {
            tab.setAttribute('aria-expanded', 'true');
            panel.classList.add('open');
          }
        });
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () { initV2Tours(document); });
  document.addEventListener('shopify:section:load', function (e) { initV2Tours(e.target); });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["v4-archive-grid"] && !Shopify.designMode) return;
  try {
    
  function initV4ArchiveVideos(root) {
    root.querySelectorAll('[data-video-wrap]').forEach(function (wrap) {
      if (wrap.dataset.initialized === 'true') return;
      wrap.dataset.initialized = 'true';

      var video = wrap.querySelector('video');
      if (!video) return;

      video.muted = true;
      video.loop = true;
      video.setAttribute('playsinline', '');

      video.addEventListener('playing', function () {
        wrap.classList.add('is-playing');
      });

      function attemptPlay() {
        var playResult = video.play();
        if (playResult && typeof playResult.catch === 'function') {
          playResult.catch(function (err) {
            console.warn('Archive video could not autoplay:', err && err.message ? err.message : err);
          });
        }
      }

      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) { attemptPlay(); } else { video.pause(); }
          });
        }, { threshold: 0.4 });
        io.observe(video);
      } else {
        attemptPlay();
      }
    });
  }

  function initV4ArchiveLightbox(root) {
    var section = root.querySelector ? root : document;
    var grid = section.querySelector ? section.querySelector('.v4-archive') : null;
    if (!grid || grid.dataset.lightboxInitialized === 'true') return;
    grid.dataset.lightboxInitialized = 'true';

    var dataEl = grid.querySelector('[data-archive-lightbox-data]');
    var items = [];
    if (dataEl) {
      try {
        items = JSON.parse(dataEl.textContent);
      } catch (e) {
        console.warn('Archive lightbox data failed to parse — the lightbox will not open:', e);
        items = [];
      }
    }

    var lightbox = grid.querySelector('[data-archive-lightbox]');
    var mediaSlot = grid.querySelector('[data-archive-lightbox-media]');
    var captionSlot = grid.querySelector('[data-archive-lightbox-caption]');
    var dateSlot = grid.querySelector('[data-archive-lightbox-date]');
    var counterSlot = grid.querySelector('[data-archive-lightbox-counter]');
    var prevBtn = grid.querySelector('[data-archive-prev]');
    var nextBtn = grid.querySelector('[data-archive-next]');
    if (!lightbox || !mediaSlot || items.length === 0) return;

    var currentIndex = 0;

    function pauseCurrentVideo() {
      var video = mediaSlot.querySelector('video');
      if (video) video.pause();
    }

    function renderItem(index) {
      var item = items[index];
      if (!item) return;
      currentIndex = index;

      if (item.type === 'video' && item.videoHtml) {
        mediaSlot.innerHTML = item.videoHtml;
      } else if (item.type === 'image' && item.imageUrl) {
        mediaSlot.innerHTML = '<img src="' + item.imageUrl + '" alt="' + (item.imageAlt || '').replace(/"/g, '&quot;') + '">';
      } else {
        mediaSlot.innerHTML = '';
      }

      captionSlot.textContent = item.caption || '';
      captionSlot.hidden = !item.caption;
      dateSlot.textContent = item.date || '';
      dateSlot.hidden = !item.date;
      if (counterSlot) counterSlot.textContent = (index + 1) + ' / ' + items.length;

      var video = mediaSlot.querySelector('video');
      if (video) {
        video.muted = false;
        var playResult = video.play();
        if (playResult && typeof playResult.catch === 'function') {
          playResult.catch(function (err) {
            console.warn('Lightbox video could not play with sound:', err && err.message ? err.message : err);
          });
        }
      }
    }

    function openLightbox(index) {
      renderItem(index);
      lightbox.classList.add('open');
      lightbox.setAttribute('aria-hidden', 'false');
    }

    function closeLightbox() {
      pauseCurrentVideo();
      lightbox.classList.remove('open');
      lightbox.setAttribute('aria-hidden', 'true');
      mediaSlot.innerHTML = '';
    }

    function goToNext() {
      pauseCurrentVideo();
      renderItem(currentIndex + 1 >= items.length ? 0 : currentIndex + 1);
    }
    function goToPrev() {
      pauseCurrentVideo();
      renderItem(currentIndex - 1 < 0 ? items.length - 1 : currentIndex - 1);
    }

    grid.querySelectorAll('[data-archive-open]').forEach(function (tile) {
      tile.addEventListener('click', function () {
        openLightbox(parseInt(tile.dataset.index, 10));
      });
    });
    grid.querySelectorAll('[data-archive-close]').forEach(function (el) {
      el.addEventListener('click', closeLightbox);
    });
    if (nextBtn) nextBtn.addEventListener('click', goToNext);
    if (prevBtn) prevBtn.addEventListener('click', goToPrev);

    document.addEventListener('keydown', function (e) {
      if (!lightbox.classList.contains('open')) return;
      if (e.key === 'Escape') closeLightbox();
      if (e.key === 'ArrowRight') goToNext();
      if (e.key === 'ArrowLeft') goToPrev();
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initV4ArchiveVideos(document);
    initV4ArchiveLightbox(document);
  });
  document.addEventListener('shopify:section:load', function (e) {
    initV4ArchiveVideos(e.target);
    initV4ArchiveLightbox(e.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["v4-empire-state"] && !Shopify.designMode) return;
  try {
    
  function initV4Countdowns(root) {
    root.querySelectorAll('[data-countdown]').forEach(function (el) {
      if (el.dataset.initialized === 'true') return;
      el.dataset.initialized = 'true';

      var targetTime = new Date(el.dataset.countdownTarget).getTime();
      if (isNaN(targetTime)) {
        console.warn('Countdown target date could not be parsed:', el.dataset.countdownTarget);
        return;
      }

      var daysEl = el.querySelector('[data-cd-days]');
      var hoursEl = el.querySelector('[data-cd-hours]');
      var minsEl = el.querySelector('[data-cd-mins]');
      var secsEl = el.querySelector('[data-cd-secs]');
      var numbersWrap = el.querySelector('[data-cd-numbers]');
      var completeMsg = el.querySelector('[data-cd-complete]');
      var timer = null;

      function pad(n) {
        return n < 10 ? '0' + n : String(n);
      }

      function tick() {
        var diff = targetTime - Date.now();
        if (diff <= 0) {
          if (numbersWrap) numbersWrap.hidden = true;
          if (completeMsg) completeMsg.hidden = false;
          if (timer) clearInterval(timer);
          return;
        }
        var days = Math.floor(diff / 86400000);
        var hours = Math.floor((diff % 86400000) / 3600000);
        var mins = Math.floor((diff % 3600000) / 60000);
        var secs = Math.floor((diff % 60000) / 1000);
        if (daysEl) daysEl.textContent = pad(days);
        if (hoursEl) hoursEl.textContent = pad(hours);
        if (minsEl) minsEl.textContent = pad(mins);
        if (secsEl) secsEl.textContent = pad(secs);
      }

      tick();
      timer = setInterval(tick, 1000);
    });
  }

  document.addEventListener('DOMContentLoaded', function () { initV4Countdowns(document); });
  document.addEventListener('shopify:section:load', function (e) { initV4Countdowns(e.target); });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["v4-fullbleed-video"] && !Shopify.designMode) return;
  try {
    
  function initV4FullbleedVideos(root) {
    root.querySelectorAll('.v4-fbv__video').forEach(function (video) {
      if (video.dataset.initialized === 'true') return;
      video.dataset.initialized = 'true';

      // autoplay/muted/playsinline are real HTML attributes already,
      // present from first paint. JS only needs to respect
      // reduced-motion (can't be read from a plain CSS media query
      // against an HTML attribute) and wire up the mute toggle.
      var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduceMotion) {
        video.pause();
        video.removeAttribute('autoplay');
      }

      var muteBtn = video.closest('.v4-fbv').querySelector('[data-mute-toggle]');
      if (muteBtn) {
        var iconMuted = muteBtn.querySelector('[data-icon-muted]');
        var iconUnmuted = muteBtn.querySelector('[data-icon-unmuted]');
        muteBtn.addEventListener('click', function () {
          video.muted = !video.muted;
          muteBtn.setAttribute('aria-pressed', video.muted ? 'true' : 'false');
          if (iconMuted) iconMuted.hidden = !video.muted;
          if (iconUnmuted) iconUnmuted.hidden = video.muted;
        });
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function () { initV4FullbleedVideos(document); });
  document.addEventListener('shopify:section:load', function (e) { initV4FullbleedVideos(e.target); });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["v4-header"] && !Shopify.designMode) return;
  try {
    
  function initV4Headers(root) {
    root.querySelectorAll('.v4-header').forEach(function (header) {
      if (header.dataset.initialized === 'true') return;
      header.dataset.initialized = 'true';

      function setHeaderHeight() {
        document.documentElement.style.setProperty('--header-height', header.offsetHeight + 'px');
      }
      setHeaderHeight();
      window.addEventListener('resize', setHeaderHeight);

      var burger = header.querySelector('[data-burger]');
      var mobileMenu = document.querySelector('[data-mobile-menu]');
      if (!burger || !mobileMenu) return;

      function openMenu() {
        mobileMenu.classList.add('open');
        mobileMenu.setAttribute('aria-hidden', 'false');
        burger.setAttribute('aria-expanded', 'true');
        burger.setAttribute('aria-label', 'Close menu');
      }
      function closeMenu() {
        mobileMenu.classList.remove('open');
        mobileMenu.setAttribute('aria-hidden', 'true');
        burger.setAttribute('aria-expanded', 'false');
        burger.setAttribute('aria-label', 'Open menu');
      }
      function toggleMenu() {
        if (burger.getAttribute('aria-expanded') === 'true') { closeMenu(); } else { openMenu(); }
      }

      burger.addEventListener('click', toggleMenu);
      mobileMenu.querySelectorAll('.v4-mobile-menu__link').forEach(function (link) {
        link.addEventListener('click', closeMenu);
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') closeMenu();
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () { initV4Headers(document); });
  document.addEventListener('shopify:section:load', function (e) { initV4Headers(e.target); });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["v4-homepage-hero-video"] && !Shopify.designMode) return;
  try {
    
  function initV4VideoHeroes(root) {
    root.querySelectorAll('.v4-video-hero__video').forEach(function (video) {
      if (video.dataset.initialized === 'true') return;
      video.dataset.initialized = 'true';

      // autoplay/muted/playsinline are real HTML attributes on this
      // element already, present from the very first paint — the only
      // thing JS still needs to do is respect reduced-motion (can't be
      // done with a plain media query against the autoplay attribute)
      // and wire up the mute toggle.
      var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduceMotion) {
        video.pause();
        video.removeAttribute('autoplay');
      }

      var muteBtn = video.closest('.v4-video-hero').querySelector('[data-mute-toggle]');
      if (muteBtn) {
        var iconMuted = muteBtn.querySelector('[data-icon-muted]');
        var iconUnmuted = muteBtn.querySelector('[data-icon-unmuted]');
        muteBtn.addEventListener('click', function () {
          video.muted = !video.muted;
          muteBtn.setAttribute('aria-pressed', video.muted ? 'true' : 'false');
          if (iconMuted) iconMuted.hidden = !video.muted;
          if (iconUnmuted) iconUnmuted.hidden = video.muted;
        });
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function () { initV4VideoHeroes(document); });
  document.addEventListener('shopify:section:load', function (e) { initV4VideoHeroes(e.target); });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["v4-media-assets"] && !Shopify.designMode) return;
  try {
    
  function initV4MediaAssets(root) {
    root.querySelectorAll('.v4-media-assets').forEach(function (section) {
      if (section.dataset.initialized === 'true') return;
      section.dataset.initialized = 'true';

      var viewport = section.querySelector('[data-viewport]');
      var track = section.querySelector('[data-track]');
      if (!viewport || !track) return;

      var slides = section.querySelectorAll('.v4-media-slide');
      var prevBtn = section.querySelector('[data-prev]');
      var nextBtn = section.querySelector('[data-next]');
      var counterCurrent = section.querySelector('[data-counter-current]');
      if (slides.length === 0) return;

      var index = 0;
      var autoplayMs = parseInt(section.dataset.autoplay || '0', 10);
      var autoplayTimer = null;
      var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      function slideWidth() { return slides[0].getBoundingClientRect().width; }
      function goTo(i) {
        index = Math.max(0, Math.min(i, slides.length - 1));
        track.style.transform = 'translateX(-' + (index * slideWidth()) + 'px)';
        if (counterCurrent) counterCurrent.textContent = index + 1;
      }

      if (prevBtn) prevBtn.addEventListener('click', function () { goTo(index - 1 < 0 ? slides.length - 1 : index - 1); resetAutoplay(); });
      if (nextBtn) nextBtn.addEventListener('click', function () { goTo(index + 1 >= slides.length ? 0 : index + 1); resetAutoplay(); });
      window.addEventListener('resize', function () { goTo(index); });

      var isDown = false, startX = 0, currentTranslate = 0;
      function pointerX(e) { return e.touches ? e.touches[0].clientX : e.clientX; }
      function startDrag(e) { isDown = true; track.classList.add('dragging'); startX = pointerX(e); currentTranslate = -index * slideWidth(); }
      function moveDrag(e) { if (!isDown) return; var dx = pointerX(e) - startX; track.style.transform = 'translateX(' + (currentTranslate + dx) + 'px)'; }
      function endDrag(e) {
        if (!isDown) return; isDown = false; track.classList.remove('dragging');
        var dx = (e.changedTouches ? e.changedTouches[0].clientX : e.clientX) - startX;
        if (dx < -50) goTo(index + 1 >= slides.length ? 0 : index + 1);
        else if (dx > 50) goTo(index - 1 < 0 ? slides.length - 1 : index - 1);
        else goTo(index);
        resetAutoplay();
      }
      track.addEventListener('mousedown', startDrag);
      window.addEventListener('mousemove', moveDrag);
      window.addEventListener('mouseup', endDrag);
      track.addEventListener('touchstart', startDrag, { passive: true });
      track.addEventListener('touchmove', moveDrag, { passive: true });
      track.addEventListener('touchend', endDrag);

      viewport.setAttribute('tabindex', '0');
      viewport.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { goTo(index + 1 >= slides.length ? 0 : index + 1); resetAutoplay(); }
        if (e.key === 'ArrowLeft') { goTo(index - 1 < 0 ? slides.length - 1 : index - 1); resetAutoplay(); }
      });

      function startAutoplay() {
        if (!autoplayMs || reduceMotion || slides.length < 2) return;
        autoplayTimer = setInterval(function () { goTo(index + 1 >= slides.length ? 0 : index + 1); }, autoplayMs);
      }
      function resetAutoplay() { if (autoplayTimer) clearInterval(autoplayTimer); startAutoplay(); }
      viewport.addEventListener('mouseenter', function () { if (autoplayTimer) clearInterval(autoplayTimer); });
      viewport.addEventListener('mouseleave', resetAutoplay);

      goTo(0);
      startAutoplay();
    });
  }

  document.addEventListener('DOMContentLoaded', function () { initV4MediaAssets(document); });
  document.addEventListener('shopify:section:load', function (e) { initV4MediaAssets(e.target); });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["v4-merch"] && !Shopify.designMode) return;
  try {
    
  function postCartAdd(url, items) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (res) {
      if (!res.ok) return res.json().then(function (err) { throw err; });
      return res.json();
    });
  }

  function refreshV4CartBadge() {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
      document.dispatchEvent(new CustomEvent('score:cart:updated', { detail: cart }));
    }).catch(function () {});
  }

  function initV4MerchTileCarousels(root) {
    root.querySelectorAll('[data-product-media]').forEach(function (media) {
      if (media.dataset.carouselInitialized === 'true') return;
      media.dataset.carouselInitialized = 'true';

      var images = media.querySelectorAll('[data-tile-image]');
      var dotsWrap = media.querySelector('[data-tile-dots]');
      if (!dotsWrap || images.length < 2) return;
      var dots = dotsWrap.querySelectorAll('[data-tile-dot]');

      function showImage(index) {
        images.forEach(function (img) {
          img.classList.toggle('is-active', parseInt(img.dataset.index, 10) === index);
        });
        dots.forEach(function (dot) {
          dot.classList.toggle('is-active', parseInt(dot.dataset.index, 10) === index);
        });
      }

      dots.forEach(function (dot) {
        dot.addEventListener('click', function (e) {
          e.preventDefault();
          showImage(parseInt(dot.dataset.index, 10));
        });
      });
    });
  }

  function initV4Merch(root) {
    initV4MerchTileCarousels(root);
    root.querySelectorAll('.v4-merch').forEach(function (hub) {
      if (hub.dataset.initialized === 'true') return;
      hub.dataset.initialized = 'true';

      var cartAddUrl = hub.dataset.cartAddUrl;
      var dataEl = hub.querySelector('[data-merch-product-data]');
      var products = [];
      if (dataEl) { try { products = JSON.parse(dataEl.textContent); } catch (e) { products = []; } }

      var overlay = hub.querySelector('[data-drawer-overlay]');
      var drawer = hub.querySelector('[data-drawer]');
      var drawerName = hub.querySelector('[data-drawer-name]');
      var sizeRow = hub.querySelector('[data-drawer-sizes]');
      var stockNote = hub.querySelector('[data-drawer-note]');
      var drawerAddBtn = hub.querySelector('[data-drawer-add]');
      var selectedVariantId = null;

      function openDrawer(productId, productName) {
        var product = products.filter(function (p) { return String(p.id) === String(productId); })[0];
        if (!product) return;
        drawerName.textContent = productName;
        sizeRow.innerHTML = '';
        stockNote.textContent = '';
        selectedVariantId = null;

        product.variants.forEach(function (variant) {
          var lowStock = variant.inventory_management === 'shopify' && variant.inventory_quantity > 0 && variant.inventory_quantity <= 5;
          var oos = !variant.available;
          var btn = document.createElement('button');
          btn.className = 'v4-size-pill';
          btn.type = 'button';
          btn.textContent = variant.title === 'Default Title' ? 'Add to Bag' : variant.title;
          if (oos) btn.disabled = true;
          btn.setAttribute('aria-pressed', 'false');
          btn.addEventListener('click', function () {
            sizeRow.querySelectorAll('.v4-size-pill').forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
            btn.setAttribute('aria-pressed', 'true');
            selectedVariantId = variant.id;
            stockNote.textContent = lowStock ? ('Only ' + variant.inventory_quantity + ' left') : '';
          });
          sizeRow.appendChild(btn);
        });

        overlay.classList.add('open'); drawer.classList.add('open'); drawer.setAttribute('aria-hidden', 'false');
      }
      function closeDrawer() {
        overlay.classList.remove('open'); drawer.classList.remove('open'); drawer.setAttribute('aria-hidden', 'true');
      }

      hub.querySelectorAll('[data-quick-add]').forEach(function (btn) {
        btn.addEventListener('click', function () { openDrawer(btn.dataset.productId, btn.dataset.productName); });
      });
      if (overlay) overlay.addEventListener('click', closeDrawer);
      var closeBtn = hub.querySelector('[data-drawer-close]');
      if (closeBtn) closeBtn.addEventListener('click', closeDrawer);

      if (drawerAddBtn) drawerAddBtn.addEventListener('click', function () {
        if (!selectedVariantId) { stockNote.textContent = 'Select an option to continue'; return; }
        drawerAddBtn.disabled = true;
        postCartAdd(cartAddUrl, [{ id: selectedVariantId, quantity: 1 }])
          .then(function () { refreshV4CartBadge(); closeDrawer(); })
          .catch(function () { stockNote.textContent = 'Could not add to cart — please try again.'; })
          .finally(function () { drawerAddBtn.disabled = false; });
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () { initV4Merch(document); });
  document.addEventListener('shopify:section:load', function (e) { initV4Merch(e.target); });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["v4-tour-posters"] && !Shopify.designMode) return;
  try {
    
  function initV4TourPosters(root) {
    root.querySelectorAll('.v4-tour-posters').forEach(function (section) {
      if (section.dataset.initialized === 'true') return;
      section.dataset.initialized = 'true';

      var viewport = section.querySelector('[data-viewport]');
      var track = section.querySelector('[data-track]');
      if (!viewport || !track) return;

      var slides = section.querySelectorAll('.v4-poster-slide');
      var prevBtn = section.querySelector('[data-prev]');
      var nextBtn = section.querySelector('[data-next]');
      var counterCurrent = section.querySelector('[data-counter-current]');
      if (slides.length === 0) return;

      var index = 0;
      var autoplayMs = parseInt(section.dataset.autoplay || '0', 10);
      var autoplayTimer = null;
      var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      function slideWidth() { return slides[0].getBoundingClientRect().width; }
      function goTo(i) {
        index = Math.max(0, Math.min(i, slides.length - 1));
        track.style.transform = 'translateX(-' + (index * slideWidth()) + 'px)';
        if (counterCurrent) counterCurrent.textContent = index + 1;
      }

      if (prevBtn) prevBtn.addEventListener('click', function () { goTo(index - 1 < 0 ? slides.length - 1 : index - 1); resetAutoplay(); });
      if (nextBtn) nextBtn.addEventListener('click', function () { goTo(index + 1 >= slides.length ? 0 : index + 1); resetAutoplay(); });
      window.addEventListener('resize', function () { goTo(index); });

      var isDown = false, startX = 0, currentTranslate = 0;
      function pointerX(e) { return e.touches ? e.touches[0].clientX : e.clientX; }
      function startDrag(e) { isDown = true; track.classList.add('dragging'); startX = pointerX(e); currentTranslate = -index * slideWidth(); }
      function moveDrag(e) { if (!isDown) return; var dx = pointerX(e) - startX; track.style.transform = 'translateX(' + (currentTranslate + dx) + 'px)'; }
      function endDrag(e) {
        if (!isDown) return; isDown = false; track.classList.remove('dragging');
        var dx = (e.changedTouches ? e.changedTouches[0].clientX : e.clientX) - startX;
        if (dx < -50) goTo(index + 1 >= slides.length ? 0 : index + 1);
        else if (dx > 50) goTo(index - 1 < 0 ? slides.length - 1 : index - 1);
        else goTo(index);
        resetAutoplay();
      }
      track.addEventListener('mousedown', startDrag);
      window.addEventListener('mousemove', moveDrag);
      window.addEventListener('mouseup', endDrag);
      track.addEventListener('touchstart', startDrag, { passive: true });
      track.addEventListener('touchmove', moveDrag, { passive: true });
      track.addEventListener('touchend', endDrag);

      viewport.setAttribute('tabindex', '0');
      viewport.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { goTo(index + 1 >= slides.length ? 0 : index + 1); resetAutoplay(); }
        if (e.key === 'ArrowLeft') { goTo(index - 1 < 0 ? slides.length - 1 : index - 1); resetAutoplay(); }
      });

      function startAutoplay() {
        if (!autoplayMs || reduceMotion || slides.length < 2) return;
        autoplayTimer = setInterval(function () {
          goTo(index + 1 >= slides.length ? 0 : index + 1);
        }, autoplayMs);
      }
      function resetAutoplay() {
        if (autoplayTimer) clearInterval(autoplayTimer);
        startAutoplay();
      }
      viewport.addEventListener('mouseenter', function () { if (autoplayTimer) clearInterval(autoplayTimer); });
      viewport.addEventListener('mouseleave', resetAutoplay);

      goTo(0);
      startAutoplay();
    });
  }

  document.addEventListener('DOMContentLoaded', function () { initV4TourPosters(document); });
  document.addEventListener('shopify:section:load', function (e) { initV4TourPosters(e.target); });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["v4-tour"] && !Shopify.designMode) return;
  try {
    
  function initV4Tours(root) {
    root.querySelectorAll('.v4-tour').forEach(function (section) {
      if (section.dataset.initialized === 'true') return;
      section.dataset.initialized = 'true';

      var pills = section.querySelectorAll('.v4-filter-pill');
      var cards = section.querySelectorAll('.v4-tour-card');
      var tabs = section.querySelectorAll('.v4-tour-card__tab');

      function applyFilter(region) {
        cards.forEach(function (card) {
          card.hidden = !(region === 'all' || card.dataset.region === region);
        });
      }
      pills.forEach(function (pill) {
        pill.addEventListener('click', function () {
          pills.forEach(function (p) { p.setAttribute('aria-pressed', 'false'); });
          pill.setAttribute('aria-pressed', 'true');
          applyFilter(pill.dataset.regionFilter);
        });
      });

      function closeAll(except) {
        tabs.forEach(function (t) { if (t !== except) t.setAttribute('aria-expanded', 'false'); });
        section.querySelectorAll('.v4-tour-card__panel').forEach(function (p) {
          if (!except || p.id !== except.getAttribute('aria-controls')) p.classList.remove('open');
        });
      }
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var panel = section.querySelector('#' + tab.getAttribute('aria-controls'));
          var isOpen = tab.getAttribute('aria-expanded') === 'true';
          closeAll(null);
          if (!isOpen && panel) {
            tab.setAttribute('aria-expanded', 'true');
            panel.classList.add('open');
          }
        });
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () { initV4Tours(document); });
  document.addEventListener('shopify:section:load', function (e) { initV4Tours(e.target); });

  } catch(e) { console.error(e); }
})();
})();
